/**
 * The global plan-cap modal store (ADR-0041 §5/§11). The API client opens it on a 402
 * (`plan_limit_reached` / `plan_feature_locked`) so a quota/feature breach surfaces as a
 * friendly cap/upsell modal anywhere in the app, never a raw error. `<CapModal>` (mounted
 * in `AppShell`) reads it. Decoupled from the client so `lib/api.ts` only sets state.
 */
import { create } from "zustand";

export interface CapDetail {
  code: string; // "plan_limit_reached" | "plan_feature_locked"
  message: string;
  metric?: string; // quota breaches
  limit?: number | null;
  feature?: string; // feature breaches
}

interface CapModalState {
  detail: CapDetail | null;
  open: (detail: CapDetail) => void;
  close: () => void;
}

export const useCapModal = create<CapModalState>((set) => ({
  detail: null,
  open: (detail) => set({ detail }),
  close: () => set({ detail: null }),
}));
